import { RouteObject } from 'react-router';
import { frekuentSpotsRoutes } from './frekuentSpotsRoutes';
import { usersRoutes } from './usersRoutes';
import { benefitsRoutes } from './benefitsRoutes';
import { financeRoutes } from './financeRoutes';
import { toolsRoutes } from './toolsRoutes';
import { settingsRoutes } from './settingsRoutes';
import { supportRoutes } from './supportRoutes';
import { marketplaceRoutes } from './marketplaceRoutes';

// Placeholder elements used for routes that are yet to be implemented

export const appRoutes: RouteObject[] = [
	{
		path: 'home',
		lazy: async () => {
			const { default: Component } = await import('@/app/pages/HomePage');
			return { Component };
		},
	},
	...frekuentSpotsRoutes,
	...usersRoutes,
	...benefitsRoutes,
	...financeRoutes,
	...toolsRoutes,
	...settingsRoutes,
	...supportRoutes,

	{
		path: 'profile',
		lazy: async () => {
			const { ProfilePage: Component } = await import('@/features/space-user');
			return { Component };
		},
	},

	...marketplaceRoutes,
];
